import { render, staticRenderFns } from "./Template44.vue?vue&type=template&id=446ed2dd&scoped=true&"
import script from "./Template44.vue?vue&type=script&lang=js&"
export * from "./Template44.vue?vue&type=script&lang=js&"
import style0 from "./Template44.vue?vue&type=style&index=0&id=446ed2dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446ed2dd",
  null
  
)

export default component.exports